// Entry point: route between sign-in, the document list (/) and the editor (/d/<id>).
import { ApiError, api, goLogin, me, sessionExpiresAt } from './api.ts';
import { openEditor } from './editor.ts';
import { showHome, showLogin } from './home.ts';
import { h, toast } from './ui.ts';

const root = document.getElementById('app')!;

async function route(): Promise<void> {
  const user = await me().catch(() => null);
  if (!user) {
    // signed out: straight to the SSO, coming back to this page afterwards (a note is shown meanwhile)
    showLogin(root);
    goLogin();
    return;
  }
  warnBeforeExpiry(sessionExpiresAt);
  const m = /^\/d\/([0-9a-f-]{36})\/?$/i.exec(location.pathname);
  if (!m) { await showHome(root, user); return; }
  try { await openEditor(root, m[1], user); }
  catch (e) {
    const status = e instanceof ApiError ? e.status : 0;
    const request = h('button', { class: 'primary', onclick: async () => {
      request.disabled = true;
      try { await api('POST', `/api/docs/${m[1]}/access-request`); request.textContent = '요청 전송됨'; }
      catch { request.disabled = false; toast('권한 요청을 보내지 못했습니다'); }
    } }, '액세스 권한 요청');
    root.replaceChildren(h('div', { class: 'notice' },
      h('h2', {}, status === 404 ? '액세스 권한이 필요합니다' : '문서를 열 수 없습니다'),
      h('p', { class: 'muted' }, status === 404 ? '소유자에게 이 문서의 액세스 권한을 요청할 수 있습니다.' : String((e as Error).message)),
      status === 404 ? request : '', h('div', { class: 'notice-home' }, h('a', { href: '/' }, '홈으로'))));
  }
}
/**
 * Ten minutes before the sign-in ends a note; changes are saved as they are made. It ends 12 hours after its last use
 * (or at the absolute limit, 12 hours after signing in: the SSO's rule), so when the time comes the server is asked
 * again (GET /api/me is not a use): another tab may have kept it going.
 */
function warnBeforeExpiry(expiresAt: string | null): void {
  const at = expiresAt ? new Date(expiresAt).getTime() : NaN;
  if (!Number.isFinite(at)) return;
  const wait = at - Date.now() - 10 * 60_000;
  setTimeout(async () => {
    if (!(await me().catch(() => null)) || !sessionExpiresAt) return;   // signed out already: the page finds out on its next request
    if (new Date(sessionExpiresAt).getTime() - Date.now() <= 10 * 60_000 + 30_000) toast('10분 후 로그인이 만료됩니다. 변경사항은 자동 저장되지만 그 뒤에는 다시 로그인해야 합니다', 10_000);
    else warnBeforeExpiry(sessionExpiresAt);
  }, Math.max(0, Math.min(wait, 2 ** 31 - 1)));   // a timer cannot be longer than ~24.8 days: then it just looks again
}
route();
